import { computed } from 'vue-demi';
import { trustedInstallations } from '../config/constants';

export default ({ userContext }) => {
  const permissions = {
    isAdminUser: false,
    isTrustedAccount: false,
    canManagePeople: false,
    canAddProjects: true,
  };

  permissions.isAdminUser = computed(() => {
    return userContext.user.value && !!userContext.user.value.administrator;
  });

  permissions.isSiteOwner = computed(() => {
    return userContext.user.value && !!userContext.user.value['site-owner'];
  });

  permissions.isTrustedAccount = computed(
    () =>
      process.env.NODE_ENV === 'development' ||
      (userContext.user.value &&
        trustedInstallations.includes(parseInt(userContext.user.value.companyId, 10))),
  );

  permissions.canManagePeople = computed(
    () =>
      userContext.user.value &&
      (userContext.user.value.administrator ||
        (userContext.user.value.permissions &&
          userContext.user.value.permissions['can-manage-people'])),
  );

  permissions.canAddProjects = computed(() => {
    return (
      userContext.user.value &&
      (userContext.user.value.administrator ||
        (userContext.user.value.permissions &&
          userContext.user.value.permissions['can-add-projects']))
    );
  });

  permissions.inOwnerCompany = computed(
    () => userContext.user.value && !!parseInt(userContext.user.value['in-owner-company'], 10),
  );

  permissions.isCollaborator = computed(
    () => userContext.user.value && userContext.user.value['user-type'] === 'collaborator',
  );

  return {
    ...permissions,
  };
};
